<template>
  <div class="content has-text-centered">
    <p>{{$t("my_card_desc")}}</p>

    <table :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}">
      <thead>
        <tr>
          <th>{{$t("card_no")}}</th>
          <th>{{$t("last_used")}}</th>
          <th>{{$t("status").tTitle()}}</th>
        </tr>
      </thead>
      <tbody v-if="cards.length > 0">
        <tr
          v-for="(c, i) in cards"
          :key="i"
        >
          <td>{{c.card_no}}</td>
          <td>{{c.last_used}}</td>
          <td>
            <span :class="{'text-red': c.status == 'ban', 'text-green': c.status == 'accept'}">{{status[c.status]}}</span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td
            class="has-text-centered text-red"
            colspan="3"
          >{{$t("you_have_no_card")}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { service } from '@/app'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      cards: {},
      status: {
        ban: 'Declined',
        accept: 'Approved',
        pending: 'Pending',
      },
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    this.getCardStatus()
  },
  methods: {
    getCardStatus() {
      service
        .post('/finance/card-get-status', {
          userID: this.User.info.ID,
        })
        .then(response => {
          this.cards = response.data.list
        })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// MyCards.vue?68b63fa5